module.exports = __webpack_public_path__ + "media/tts_g1_h.72d7d8bc.mp3";